import { ISelectOption } from 'src/lib';
import { ValueTransformer } from './value-transform';

// eslint-disable-next-line import/prefer-default-export
export class ConfigDiffFinder {
  static isObjectDifferent(
    oldConfiguration: unknown,
    newConfiguration: unknown
  ): boolean {
    // If both the objects are null or undefined then no difference between them
    if (
      ValueTransformer.isNullOrUndefined(oldConfiguration) &&
      ValueTransformer.isNullOrUndefined(newConfiguration)
    ) {
      return false;
    }
    // If any one of them is null or undefined, then they are different now
    if (
      ValueTransformer.isNullOrUndefined(oldConfiguration) ||
      ValueTransformer.isNullOrUndefined(newConfiguration)
    ) {
      return true;
    }
    if (
      typeof oldConfiguration === 'object' &&
      typeof newConfiguration === 'object'
    ) {
      if (Array.isArray(oldConfiguration) && Array.isArray(newConfiguration)) {
        return ConfigDiffFinder.isArrayConfigChanged(
          oldConfiguration,
          newConfiguration
        );
      }
      if (Array.isArray(oldConfiguration) || Array.isArray(newConfiguration)) {
        return true;
      }
      if (
        Object.keys(oldConfiguration).length !==
        Object.keys(newConfiguration).length
      ) {
        return true;
      }
      return (
        Object.keys(oldConfiguration || {}).filter((key) =>
          ConfigDiffFinder.isObjectDifferent(
            oldConfiguration[key],
            newConfiguration[key]
          )
        ).length > 0
      );
    }
    if (
      typeof oldConfiguration === 'string' &&
      typeof newConfiguration === 'string'
    ) {
      return ConfigDiffFinder.isPrimitiveTypeValueChanged(
        oldConfiguration,
        newConfiguration
      );
    }
    if (
      typeof oldConfiguration === 'number' &&
      typeof newConfiguration === 'number'
    ) {
      return ConfigDiffFinder.isPrimitiveTypeValueChanged(
        oldConfiguration,
        newConfiguration
      );
    }
    if (
      typeof oldConfiguration === 'boolean' &&
      typeof newConfiguration === 'boolean'
    ) {
      return ConfigDiffFinder.isPrimitiveTypeValueChanged(
        oldConfiguration,
        newConfiguration
      );
    }
    return true;
  }

  private static isPrimitiveTypeValueChanged(
    oldValue: string | number | boolean,
    newValue: string | number | boolean
  ) {
    return oldValue.toString() !== newValue.toString();
  }

  static isArrayConfigChanged(
    oldArray: ISelectOption[],
    newArray: ISelectOption[]
  ) {
    if (oldArray.length !== newArray.length) {
      return true;
    }
    return oldArray.some(
      (config) => !newArray.find((arr) => arr.value === config.value)
    );
  }
}
